exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-78e821d1] .v-divider {\n  border-color: gray;\n  margin: 0px;\n}\n", ""]);

// exports
